import { Channel, LocalMessage } from "stream-chat";

export const getIsLastMessageRead = (
  channel?: Channel,
  lastMessage?: LocalMessage,
  currentUserId?: string,
) => {
  if (!channel || !lastMessage || !currentUserId) return false;

  const isOwnLastMessage = lastMessage.user?.id === currentUserId;
  if (!isOwnLastMessage) return false;

  const readStates = Object.values(channel.state.read ?? {});

  return readStates.some(
    (readState) =>
      readState.user.id !== currentUserId &&
      readState.last_read_message_id === lastMessage.id,
  );
};

export const isLastMessageRead = (
  channel?: Channel,
  lastMessage?: LocalMessage,
  currentUserId?: string,
) => getIsLastMessageRead(channel, lastMessage, currentUserId);
